import React from "react";
import MobileAppBar from "./MobileAppBar";
import { useAuthUser } from "../../context/UserManager";
import { useUserData } from "../../context/UserDataFetcher";
import { useTheme } from "@mui/material/styles";
import { useUserControls } from "../../context/UserControlsProvider";
import { green } from "@mui/material/colors";

const MoreViewAppBar: React.FC<{ position?: 'fixed' | 'static' }> = ({ position = 'fixed' }) => {
  const { authUser } = useAuthUser();
  const userData = useUserData();
  const theme = useTheme();
  const { processedGroups, unprocessedGroups, selectedShipmentObject } = useUserControls();

  const rawTitle = authUser?.email ?? "Account";

  let rawSubtitle: string = "";
  if (userData) {
    const role = (userData as any).role;
    if (role === "dealer") rawSubtitle = (userData as any).dealerId ?? "";
    else if (role === "manufacturer") rawSubtitle = (userData as any).manufacturerId ?? "";
    else rawSubtitle = String(role ?? "");
  }

  // Normalize casing for header/subheader (capitalize first letter only)
  const capitalizeFirst = (s: string) => (s && s.length > 0 ? s.charAt(0).toUpperCase() + s.slice(1) : s);
  const title = typeof rawTitle === "string" ? capitalizeFirst(rawTitle) : rawTitle;
  const subtitle: React.ReactNode = typeof rawSubtitle === "string" ? capitalizeFirst(rawSubtitle) : rawSubtitle;

  // Match theming with other tabs
  const fg = (theme as any)?.palette?.primary?.contrastText ?? "#fff";
  const processedCount = React.useMemo(
    () => Object.values(processedGroups).flat().length,
    [processedGroups]
  );
  const unprocessedCount = React.useMemo(
    () => Object.values(unprocessedGroups).flat().length,
    [unprocessedGroups]
  );
  const itemCount = processedCount + unprocessedCount;
  const allProcessed = itemCount > 0 && processedCount === itemCount && !!selectedShipmentObject;
  const bg = allProcessed
    ? green[800]
    : (theme as any)?.brand ?? theme.palette.primary.main;

  return (
    <MobileAppBar
      title={title}
      subtitle={subtitle}
      backgroundColor={bg}
      textColor={fg}
      position={position}
    />
  );
};

export default MoreViewAppBar;
